/**
 * Ferien im Stundenplan (F-22) - rein und getestet. In den Ferien fallen die
 * Schulstunden aus: sie verschwinden aus Kalender, Uebersicht und "Heute".
 * Klausuren und andere einzelne Termine bleiben stehen.
 */
import { datePart, isLocalDate } from '@/lib/datetime';
import type { CalendarOccurrence, Ferien, LocalDate } from '@/domain/types';

export function ferienAm(ferien: readonly Ferien[], datum: LocalDate): Ferien | undefined {
  return ferien.find((f) => f.von <= datum && datum <= f.bis);
}

/**
 * Eine Schulstunde ist ein Vorkommen einer Serie mit Fach. Klausuren haben
 * zwar auch ein Fach, sind aber einzelne Termine - sie zaehlen nie als Stunde.
 */
export function istSchulstunde(o: CalendarOccurrence): boolean {
  return Boolean(o.subjectId) && o.isRecurring && !o.allDay;
}

/** Schulstunden an Ferientagen herausnehmen. */
export function ohneFerien(occ: CalendarOccurrence[], ferien: Ferien[]): CalendarOccurrence[] {
  if (ferien.length === 0) return occ;
  return occ.filter((o) => !(istSchulstunde(o) && ferienAm(ferien, datePart(String(o.start) as LocalDate))));
}

/** Laufende oder naechste Ferien ab heute. */
export function naechsteFerien(ferien: Ferien[], heute: LocalDate): Ferien | undefined {
  return [...ferien].filter((f) => f.bis >= heute).sort((a, b) => a.von.localeCompare(b.von))[0];
}

/** Pruefung an der Eingabe: zwei gueltige Tage, Ende nicht vor dem Anfang. */
export function ferienGueltig(von: string, bis: string): boolean {
  return isLocalDate(von) && isLocalDate(bis) && von <= bis;
}
